<template>
  <PrintPage :pageNumber="pageNumber" :pageCount="pageCount">
    <template v-slot:header>
      <slot>
        <div class="header-grid"></div>
      </slot>
    </template>

    <div class="content-box">
      <div class="content-box-header">
        <h3>{{ $t('electricMeterChange') }} - Neuer Zähler (Einbau) eHZ</h3>
      </div>

      <div class="two-column-grid">
        <div>{{ $t('electricMeterChangeAttachment_3') }}</div>
        <div>
          <img
            v-if="project.enpalReport.electricMeterChangeAttachment_3"
            :src="project.enpalReport.electricMeterChangeAttachment_3.path"
          />
        </div>
        <div>{{ $t('electricMeterChangeAttachment_4') }}</div>
        <div>
          <img
            v-if="project.enpalReport.electricMeterChangeAttachment_4"
            :src="project.enpalReport.electricMeterChangeAttachment_4.path"
          />
        </div>
      </div>

      <div class="two-column-grid">
        <div>{{ $t('electricMeterChange_12') }}</div>
        <div>
          {{ project.enpalReport.electricMeterChange_12 }}
        </div>
      </div>

      <div class="two-column-grid">
        <div>{{ $t('electricMeterChangeAttachment_5') }}</div>
        <div>
          <img
            v-if="project.enpalReport.electricMeterChangeAttachment_5"
            :src="project.enpalReport.electricMeterChangeAttachment_5.path"
          />
        </div>
      </div>
      <div class="two-column-grid">
        <div>{{ $t('electricMeterChange_13') }}</div>
        <div>
          {{ project.enpalReport.electricMeterChange_13 }}
        </div>
        <div>{{ $t('electricMeterChange_14') }}</div>
        <div>
          {{ project.enpalReport.electricMeterChange_14 }}
        </div>
        <div>{{ $t('electricMeterChange_15') }}</div>
        <div>
          {{ project.enpalReport.electricMeterChange_15 }}
        </div>
      </div>
    </div>
  </PrintPage>
</template>

<script>
import PrintPage from '@/components/Print/PrintPage';

export default {
  components: {
    PrintPage,
  },
  props: {
    project: null,
    pageCount: { type: Number, default: 1 },
    pageNumber: { type: Number, default: 0 },
  },
  methods: {
    range(min, max) {
      const array = [];
      let j = 0;
      for (var i = min; i <= max; i++) {
        array[j] = i;
        j++;
      }
      return array;
    },
  },
};
</script>

<style src="./ReportPrintPage.scss" lang="scss" />
